import React, {useEffect, useState} from 'react';
import {AppContext} from './utils/appContext';
import {getCurrentWebsite} from "./utils/helpers";
import {ToastContainer} from "react-toastify";
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n';
import moment from 'moment-timezone';
import {IAppContext, IComplaint, IHelpForm} from "./interfaces/assistanceContext";
import ReCAPTCHA from 'react-google-recaptcha';
import i18next, {use} from "i18next";
import {useLocation} from "react-router-dom";

declare global {
    interface Window {
        current_lang: string;
    }
}

const complaintEmpty: IComplaint = {
    GuestFirstname: '',
    GuestName: '',
    Email: '',
    ReservationNumber: '',
    Note: '',
    Attachment: [],
    Reasons: '',
    GuestArrival: null,
    GuestDeparture: null,
    Property: '',
}

const helpFormEmpty: IHelpForm = {
    GuestFirstname: '',
    GuestName: '',
    Email: '',
    Argument: '',
    ReservationNumber: '',
    RoomNumber: '',
    Note: '',
    Attachment: [],
    GuestArrival: null,
    GuestDeparture: null,
    CheckboxIntervention: false,
    Property: ''
}

const Main = (props: { children: React.ReactNode; }) => {

    const [website, setWebsite] = useState(getCurrentWebsite());
    const [language, setLanguage] = useState(i18next.language);
    const [complaint, setComplaint] = useState<IComplaint>(complaintEmpty);
    const [helpForm, setHelpForm] = useState<IHelpForm>(helpFormEmpty);
    const [helpReason, setHelpReason] = useState<number>(0);

    useEffect(() => {
        moment.updateLocale(language, {
            week: {
                dow: 1
            }
        });
    }, [i18next.language]);

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const propertyParams = queryParams.get('property');
    const recaptchaRef = React.useRef({} as ReCAPTCHA);

    const selector = 'property=';
    const slice = window.location.search.indexOf(selector) + selector.length
    const property = window.location.search.slice(slice, slice + 2);

    const getTokenRecaptcha = async () => {
		  return recaptchaRef.current.executeAsync();
	  }

    const value: IAppContext = {
        website,
        setWebsite,
        language,
        setLanguage,
        complaint,
        setComplaint,
        helpForm,
        setHelpForm,
        helpReason,
        setHelpReason,
        getTokenRecaptcha,
        property
    };

    return <AppContext.Provider value={value}>
        <I18nextProvider i18n={i18n}>
            <ReCAPTCHA
                sitekey="6LcB5JQpAAAAAMXG8BUqeHGI07MFoB2wPKl3U2Ru"
                size={'invisible'}
                ref={recaptchaRef}
                hl={language}
            />
            <main>{props.children}</main>
            <ToastContainer/>
        </I18nextProvider>
    </AppContext.Provider>
};

export default Main;
